import React from "react"
import SEO from "../../../components/seo"
import StandardContentSection from "../../../components/atoms/StandardContentSection"
import Layout from "../../../components/layout"
import { Service } from "../../../assets/types"
import { Box } from "@mui/material"
import ServiceSectionProblem from "../../../components/molecules/ServiceSection/Problem"
import ServiceSectionIntroduction from "../../../components/molecules/ServiceSection/Introduction"
import ServiceSectionDeliveryFlow from "../../../components/molecules/ServiceSection/DeliveryFlow"
import ServiceSectionFeePlan from "../../../components/molecules/ServiceSection/FeePlan"
import CTAButton from "../../../components/atoms/Button/CTAButton"

interface PageProps {}

const IndexPage: React.FC<PageProps> = () => {
  const services: Service[] = require("../../../../contents/json/services.json")
    .items
    .filter((service: Service) => service.code === "GA-1001");
  if (services.length !== 1) {
    throw new Error("指定されたサービスが見つかりません。")
  }
  const service: Service = services[0]
  return (
    <Layout breadcrumbs={[
      { to: '/', label: 'Home' },
      { to: '/services/', label: 'サービス一覧'},
      { to: '/services/GA-1001/', label: service.name }
    ]}>
      <h2>{service.name}</h2>
      <StandardContentSection className="service-page-item">
        <Box sx={{ marginBottom: "24px" }}>
          <ServiceSectionProblem service={service} />
          <ServiceSectionIntroduction service={service} />
          <ServiceSectionDeliveryFlow service={service} />
          <ServiceSectionFeePlan service={service} />

          <Box sx={{ marginTop: "64px", height: "64px", fontSize: "1.4em" }}>
            <CTAButton link="/contact/form/" text="SEM Technologyに相談する" />
          </Box>
        </Box>
      </StandardContentSection>
    </Layout>
  )
}

export default IndexPage
export const Head = () => {
  const services: Service[] = require("../../../../contents/json/services.json")
    .items
    .filter((service: Service) => service.code === "GA-1001");
  if (services.length !== 1) {
    throw new Error("指定されたサービスが見つかりません。")
  }
  const service: Service = services[0]
  return  (
    <SEO title={`${service.name} | サービス紹介 | SEM Technology`}
      keywords={[]}
      description={service.description}
      meta={[]}
      thumbnail={""}
      jsonld={[]}
    />
  )
}
